const Welcome = {
  path: "",
  name: "welcome",
  redirect: "/welcome",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/welcome",
      redirect: "/welcome",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Welcome",
      meta: {
        requiresAuth: true,
        activeUrl: "/welcome",
        parent: "/welcome",
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/Welcome"),
          meta: {
            requiresAuth: true,
            activeUrl: "/welcome",
            parent: "/welcome",
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Welcome;
